/**
 * Servicio para extraer y transformar datos del evento (Desktop vs Mobile)
 * Centraliza la lógica de parsing del evento según el tamaño de pantalla
 */

export class EventDataExtractor {
  /**
   * Desktop breakpoint
   */
  static DESKTOP_BREAKPOINT = 770;

  /**
   * Extrae datos de promoción y prevención del evento
   * Maneja diferencias entre Desktop (objeto) y Mobile (atributos HTML)
   * @param {object} event - Evento del formulario
   * @param {boolean} isDesktop - Indica si es vista desktop
   * @returns {object}
   */
  static extractPromotionData(event, isDesktop = true) {
    if (isDesktop) {
      return {
        promotionInfo: event.PromotionAndPreventionInfo,
        promotion: event.Promotion,
        description: event.Description,
        imageUrl: event.ImageUrl,
        name: event.Name,
        nameService: event.NameService,
      };
    } else {
      const selectedIndex = event.target.selectedIndex;
      const options = event.target.options;
      return {
        promotionInfo: options[selectedIndex].getAttribute('data-PromotionAndPreventionInfo'),
        promotion: options[selectedIndex].getAttribute('data-Promotion'),
        description: options[selectedIndex].getAttribute('data-Description'),
        imageUrl: options[selectedIndex].getAttribute('data-ImageUrl'),
        name: options[selectedIndex].getAttribute('data-Name'),
        nameService: options[selectedIndex].text,
      };
    }
  }

  /**
   * Valida si los datos de promoción están activos
   * @param {string} promotionInfo - String con info de promoción
   * @returns {boolean}
   */
  static isPromotionActive(promotionInfo) {
    return promotionInfo !== null && promotionInfo !== undefined;
  }

  /**
   * Extrae el valor de la especialidad seleccionada
   * @param {object} event - Evento del formulario
   * @param {boolean} isDesktop - Indica si es vista desktop
   * @returns {string}
   */
  static getSpecialtyValue(event, isDesktop = true) {
    if (isDesktop) {
      return event.value;
    } else {
      return event.target.value;
    }
  }

  /**
   * Extrae todos los datos relevantes del evento de forma unificada
   * @param {object} event - Evento del formulario
   * @returns {object}
   */
  static extractAllEventData(event) {
    const isDesktop = window.innerWidth >= this.DESKTOP_BREAKPOINT;
    const specialtyValue = this.getSpecialtyValue(event, isDesktop);
    const promotionData = this.extractPromotionData(event, isDesktop);

    return {
      isDesktop: isDesktop,
      specialtyValue: specialtyValue,
      agrupador: event.Agrupador || 0,
      promotionData: promotionData,
      isPromotionActive: this.isPromotionActive(promotionData.promotionInfo),
      validationDataPromotion: !this.isPromotionActive(promotionData.promotionInfo) ? false : true,
    };
  }

  /**
   * Construye el objeto de información para mostrar en el estado del componente
   * @param {object} promotionData - Datos de promoción extraídos
   * @returns {object}
   */
  static buildDisplayInfo(promotionData) {
    return {
      name: promotionData.name,
      image: promotionData.imageUrl,
      description: promotionData.description,
    };
  }
}
